export const GET_APP_CONFIG = '@@appConfig/getAppConfig'
export const SAVE_CONFIG_INFO = '@@appConfig/saveAppConfig'
export const RESET_APP_CONFIG = '@@appConfig/resetAppConfig'
export const SAVE_RAW_CONFIG = '@@appConfig/saveRawConfig'
